import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appNumberWithTwoDecimals]'
})
export class NumberWithTwoDecimalsDirective {
  // Allow decimal numbers and negative values
  // Permit decimals with "."" or ,
  private regex: RegExp = new RegExp(/^\d{1}\d*(\,|\.)?\d{0,1}$/g);
  // Allow key codes for special events
  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', ',', '.', 'ArrowLeft', 'ArrowRight', 'Del', 'Delete'];

  constructor(private el: ElementRef) {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    // Allow special keys
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }
    const current: string = this.el.nativeElement.value;
    const position = this.el.nativeElement.selectionStart;
    const next: string = [current.slice(0, position), event.key === 'Decimal' ? ',' : event.key, current.slice(position)].join('');

    // If not check regular expression do nothing
    if (next && !String(next).match(this.regex)) {
      event.preventDefault();
    }
  }

}
